import { Injectable } from '@angular/core';
import { GlobalParamService } from './globalParam.service';


@Injectable({
  providedIn: 'root'
})
export class PriceService{
	
	priceBase:any;
	distanceBase:any;
	priceKm:any;
	factor:any;

	constructor(private params: GlobalParamService) { 
		this.init();
	}
	
	async init(){
		this.priceBase=await this.params.getParamValueAsString("priceBase");
    this.distanceBase=await this.params.getParamValueAsString("distanceBase");
		this.priceKm=await this.params.getParamValueAsString("priceKm");
		this.factor=await this.params.getParamValueAsString("factor");
    this.priceBase=Number(this.priceBase);
    this.distanceBase=Number(this.distanceBase);
		this.priceKm=Number(this.priceKm);
		this.factor=Number(this.factor);
	}

	round(number, precision) {
    var factor = Math.pow(10, precision);
    var tempNumber = number * factor;
    var roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
	}

	/**
	 * Redondeo de precio según factor 
	 * @param price 	Precio exacto
	 * @param factor 	Cantidad de centavos de redodneo: 20 (ctvs), 25 (ctvs) 
	 */
	roundPrice(price, factor?:number){
		if(factor===undefined)
			factor = this.factor;

		let nInteger:number =  Math.floor(price / (factor / 100));
		const nDecimal:number =  (price / (factor / 100)) - nInteger;

		if(nDecimal>=0.5)
			nInteger = nInteger + 1;
		
		return this.round(nInteger * (factor / 100), 2);
	}

	calculatePrice(distance: number){
    let price: number;
    let dif = distance - this.distanceBase;
    if(dif < 0){
      price = this.priceBase;
    }else{
      price = this.priceBase + dif * this.priceKm;
    }

    return this.roundPrice(price);
	}
	
}
